export class SlideModel {
    id: number;
    code: string;
    name: string;
    concurrencyStamp: string;
    isEnabled: boolean;
    title: string;
    subTitle: string;
    imagePath: string;
    fileName: string;
    fileExtension: string;
    fileBase64String: string;
    cssClass: string;
    buttonName: string;
    link: string;
}
